class Microtag {

  constructor (data) {
    if (data !== undefined) {
      Object.entries(data).forEach(([key, value]) => {
        this[key] = value
      })
    }
  }

  prepareForSend () {
    return _.cloneDeep(this)
  }
}

export {
  Microtag as default
}



// WEBPACK FOOTER //
// ./src/models/microtag.js